import {
  Component,
  computed,
  inject,
  OnInit,
  Signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { LookupList } from '../../../../../core/models/lookup-list.model';
import { LookupListService } from '../../../../../core/services/lookup-list.service';
import { TranslatePipe } from '../../../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-readonly-field',
  imports: [FormlyModule, TranslatePipe],
  templateUrl: './readonly-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './readonly-field.component.css',
})
export class ReadonlyFieldComponent extends FieldType<FieldTypeConfig> implements OnInit {
  private lookupListService = inject(LookupListService);
  private _lookupListSignal: Signal<LookupList | null> | null = null;

  ngOnInit(): void {
    const optionsSource = this.props['optionsSource'] as string | undefined;
    const lookupListId = this.props['lookupListId'] as string | undefined;
    if (optionsSource === 'lookup-list' && lookupListId) {
      const query = this.lookupListService.createQueryById(lookupListId);
      this._lookupListSignal = query.data;
    }
  }

  get originalType(): string {
    return (this.props['originalType'] as string) ?? 'text';
  }

  get resolvedOptions(): { value: any; label: string }[] {
    if (this._lookupListSignal) {
      return this._lookupListSignal()?.options ?? [];
    }
    const opts = this.props['options'] as any;
    return Array.isArray(opts) ? opts : [];
  }

  displayValue = computed(() => {
    const value = this.formControl.value;
    if (value === null || value === undefined || value === '') {
      return null;
    }

    switch (this.originalType) {
      case 'checkbox':
        return value ? 'submission.view.checkbox.yes' : 'submission.view.checkbox.no';

      case 'radio':
      case 'dropdown': {
        const opt = this.resolvedOptions.find((o) => o.value === value);
        return opt?.label ?? String(value);
      }

      case 'select':
      case 'checkbox-group': {
        if (Array.isArray(value)) {
          return value
            .map((v) => this.resolvedOptions.find((o) => o.value === v)?.label ?? String(v))
            .join(', ');
        }
        const opt = this.resolvedOptions.find((o) => o.value === value);
        return opt?.label ?? String(value);
      }

      default:
        return String(value);
    }
  });

  get isCheckbox(): boolean {
    return this.originalType === 'checkbox';
  }
}
